import api from "../..";
import type { DeleteSkyroomParams } from "./types";

export const deleteSkyroom = async ({ id }: DeleteSkyroomParams): Promise<boolean> => {

  return await api.delete(`/skyroom/${id}/`)
  .then(() => true).
  catch(() => false);
};